import React, { useState, useEffect, useRef } from 'react';

const MultiSelectDropdown = ({ sites, onChange, loading, selectedSites, setSelectedSites }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (site) => {
    // Check if this site is already selected by comparing site names
    const isSelected = selectedSites.some(item => item.site === site.site);
    
    const updatedSelection = isSelected
      ? selectedSites.filter(item => item.site !== site.site)
      : [...selectedSites, { site: site.site, hwid: site.hwid }];
    
    setSelectedSites(updatedSelection);
    
    // Notify parent component about the change
    if (onChange) {
      onChange(updatedSelection);
    }
  };

  const handleSelectAll = () => {
    if (selectedSites.length === sites.length) {
      // If all are selected, deselect all
      setSelectedSites([]);
    } else {
      // Otherwise, select all
      const allSites = sites.map(site => ({ site: site.site, hwid: site.hwid }));
      setSelectedSites(allSites);
    }
    
    // Notify parent component
    if (onChange) {
      onChange(selectedSites.length === sites.length ? [] : sites.map(site => ({ site: site.site, hwid: site.hwid })));
    }
  };

  const allSelected = sites.length > 0 && selectedSites.length === sites.length;

  return (
    <div data-testid="dropdown-container"
      ref={dropdownRef} style={{backgroundColor:"#15253D"}}>
      <div
        data-testid="dropdown-button"
        onClick={handleToggle}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '3px 5px',
          borderRadius: '4px',
          cursor: 'pointer',
        }}
      >
        <span>{selectedSites.length} Selected</span>
        <span style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>▼</span>
      </div>
      
      {isOpen && (
        <div 
          style={{
            position: 'absolute',
            maxHeight: '300px',
            overflowY: 'auto',
            border: '1px solid #ccc',
            borderTop: 'none',
            borderRadius: '0 0 4px 4px',
            zIndex: 10,
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
          }}
        >
          {/* Select All option */}
          <div 
            style={{
            padding: '3px 5px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              borderBottom: '1px solid #eee',
              fontWeight: 'bold',
              backgroundColor: allSelected ? 'black' : '#2B3441'
            }}
            onClick={handleSelectAll}
          >
            <input
              type="checkbox"
              checked={allSelected}
              onChange={() => {}}
              style={{ marginRight: '10px' }}
            />
            <span>Select All</span>
          </div>

          {/* Individual options */}
          {sites.map((site, index) => (
            <div 
              key={index}
              style={{
                padding: '3px 5px',
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                backgroundColor: selectedSites.some(item => item.site === site.site) ? 'black' : '#2B3441',
                borderBottom: index < sites.length - 1 ? '1px solid #eee' : 'none'
              }}
              onClick={() => handleCheckboxChange(site)}
            >
              <input
                type="checkbox"
                checked={selectedSites.some(item => item.site === site.site)}
                onChange={() => {}}
                style={{ marginRight: '10px' }}
              />
              <span>{site.site}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


export default MultiSelectDropdown;